<div
  class="chat-message"
  [class.user-message]="currentUserMessage">

  @if (!mappedMessage.sender?.bot || !aiChatBotIcon) {
    <lib-user-avatar class="sender-avatar" [size]="32" [user]="mappedMessage?.sender"></lib-user-avatar>
  } @else {
    <lib-svg-icon [url]="aiChatBotIcon?.uri" [size]="32"></lib-svg-icon>
  }


  <div class="chat-message-body">
    @if (canDelete || canEdit) {
      <lib-icon
        class="chat-message-context-button"
        icon="dots-three-vertical"
        [size]="16"
        [matMenuTriggerFor]="chatMenu">
      </lib-icon>
    }

    <mat-menu #chatMenu="matMenu" class="base-context-menu">
      @if (canEdit) {
        <button class="base-menu-button" mat-menu-item (click)="editMessage()">
          <lib-icon icon="pencil-simple"></lib-icon>
          {{'CHAT.edit' | translate}}
        </button>
      }

      @if (canDelete) {
        <button class="base-menu-button" mat-menu-item (click)="deleteMessage()">
          <lib-icon icon="trash"></lib-icon>
          {{'CHAT.delete' | translate}}
        </button>
      }
    </mat-menu>

    <div class="chat-message-head">
      <span class="message-sender">{{ mappedMessage?.sender?.fullname }}</span>

      <span class="message-date">{{ mappedMessage?.timestamp | customDate: 'dateTimeMin' }}</span>
    </div>

    @switch (mappedMessage?.type) {
      @case (messageTypes.VIDEO_MESSAGE) {
        <lib-recorded-video-message
          [theme]="currentUserMessage ? 'primary' : 'default'"
          [videoShape]="mappedMessage?.media?.options?.layout"
          [video]="(mappedMessage?.media?.file$ | async)"
          [src]="mappedMessage?.media?.url || (mappedMessage?.media?.file$ | async)?.presignedUrl">
        </lib-recorded-video-message>
      }
      @case (messageTypes.AUDIO_MESSAGE) {
        <lib-audio-waveform-player
          [theme]="currentUserMessage ? 'primary' : 'default'"
          [src]="mappedMessage?.media?.url || (mappedMessage?.media?.file$ | async)?.presignedUrl">
        </lib-audio-waveform-player>
      }
      @case (messageTypes.IMAGE_MESSAGE) {
        <div
          class="user-media-message-wrapper"
          [modalImage]="{ url: mappedMessage?.media?.url || ((mappedMessage?.media?.file$ | async)?.presignedUrl) }">
          <img
            class="user-media-message"
            [attr.alt]="'COMMON.image' | translate"
            [src]="mappedMessage?.media?.url || (mappedMessage?.media?.file$ | async)?.presignedUrl"
            (load)="mediaLoaded.emit()">
        </div>
      }
      @case (messageTypes.FILE_MESSAGE) {
        <div class="message-content">
          <lib-icon icon="paperclip"></lib-icon>
          <a [attr.href]="mappedMessage?.media?.url || (mappedMessage?.media?.file$ | async)?.presignedUrl" target="_blank">{{ (mappedMessage?.media?.file$ | async)?.filename || (mappedMessage?.media?.file$ | async)?.name || mappedMessage?.media?.filename }}</a>
        </div>
      }
      @case (messageTypes.LOADING_MESSAGE) {
        <div class="message-content">
          <app-chat-message-loading></app-chat-message-loading>
        </div>
      }
      @case (messageTypes.ADAPTIVE_CARD) {
        <app-chat-adaptive-card
          [adaptiveCard]="mappedMessage.adaptiveCardContent"
        (submitAction)="submitAction.emit($event)"></app-chat-adaptive-card>
      }
      @default {
        <div class="message-content message-content--text" [innerHtml]="mappedMessage?.message | chatMessage:!htmlMessage"></div>
      }
    }
  </div>
</div>
